/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */

var nb = require('../../nb');
module.exports = nb.define({
    parent: require('../../Page'),
    slot: {
        content: ['html', {
            $type: require('./view/Content'),
            $model: 'content'
        }]
    },
    method: {
        init: function () {
            var self = this;
            this.$().on('click', '.product-item', function (e) {
                self._checkIsLogin(e);
            });
            this.$().on('click', '.type-item', function (e) {
                self._checkIsLogin(e);
            });
            this.$().on('click', '.brand-item', function (e) {
                self._checkIsLogin(e);
            });
        },
        _checkIsLogin: function (e) {
            var userModel = require('../../model/User');
            var loginReady = userModel.get('loginReady');  //有无token
            var modal = require('../../model/modal/login/Login');
            if (!loginReady) {  //无token 弹登录
                modal.set('show',new Date());
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
            }
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/Page.js
// module id = 504
// module chunks = 6